module.exports = __webpack_public_path__ + "static/media/on-the-table.da7bf3c4.svg";